import axiosClient from 'utils/axiosClient';
import { SubGenre } from '../../models/SubGenre';

export interface SubGenreResponse {
  status: string;
  message: string;
  data: SubGenre[];
}

const service = {
  getSubGenres(name: string, fairFlg: number, deleteFlg: number): Promise<SubGenreResponse> {
    const url = `sub-genres?name=${name}&fair_flg=${fairFlg}&delete_flg=${deleteFlg}`;
    return axiosClient.get(url);
  },
  deleteSubGenres(ids: string): Promise<SubGenreResponse> {
    const body = {
      ids: ids,
    };
    const url = `sub-genre/delete-multi`;
    return axiosClient.post(url, body);
  },
  restoreDelete(id: number): Promise<SubGenreResponse> {
    const body = {
      id: id,
    };
    const url = `sub-genre/restore-delete`;
    return axiosClient.post(url, body);
  },
};

export default service;
